// extracted by mini-css-extract-plugin
module.exports = {"inFocus":"qsf3U","title":"ywSlc","links":"FJt6H"};